import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateDepartmentPayload,
  DepartmentDto,
  UpdateDepartmentPayload,
} from '@/types/department';
import type { ListFilterPayload } from '@/types/filters';

interface GetDepartmentsParams {
  page?: number;
  size?: number;
  sort?: string;
}

// ============================================
// Departments CRUD — /platform-service/v1/departments
// ============================================

export const getDepartments = async (
  params: GetDepartmentsParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<DepartmentDto>> => {
  const response = await api.post<PaginatedResponse<DepartmentDto>>(
    '/platform-service/v1/departments/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const getDepartmentById = async (id: string): Promise<DepartmentDto> => {
  const response = await api.get<DepartmentDto>(`/platform-service/v1/departments/${id}`);
  return response.data;
};

export const createDepartment = async (
  data: CreateDepartmentPayload,
): Promise<DepartmentDto> => {
  const response = await api.post<DepartmentDto>('/platform-service/v1/departments', data, {
    successToast: true,
  });
  return response.data;
};

export const updateDepartment = async (
  id: string,
  data: UpdateDepartmentPayload,
): Promise<DepartmentDto> => {
  const response = await api.put<DepartmentDto>(
    `/platform-service/v1/departments/${id}`,
    data,
    { successToast: true },
  );
  return response.data;
};

export const deleteDepartment = async (id: string): Promise<void> => {
  await api.delete(`/platform-service/v1/departments/${id}`, { successToast: true });
};
